module.exports = __webpack_public_path__ + "dist/img/code.db39ac43.jpg";